module.exports = __webpack_public_path__ + "static/img/f_first_02.778bf7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_02.png
// module id = vPGa
// module chunks = 9